// Where a user lands after logging in, and where a blocked route bounces them.
//
// One landing page for everyone: the DASHBOARD (user 2026-08-28). Super Admin used
// to open on All Sales and Accountant on All Sales Comm; both now start on the
// dashboard like everybody else.
//
// Two roles still can't use it, so they keep their own landing page — sending them
// to a page they're barred from would bounce them straight back out:
//   • Viewer-only — protectedRoute explicitly redirects them off /dashboard.
//   • Astern Admin — the dashboard is hidden from their menu.
export function getDefaultRoute(roles = [], canCreateSale = true) {
    const list = Array.isArray(roles) ? roles : [];

    // Referral-only means EVERY role is Referral — someone who also sells keeps the
    // normal landing page. Checked BEFORE the training room on purpose: a referrer
    // may not create a sale, so canCreateSale is false for them and always will be,
    // but the RSC quiz examines a calculator they never open. Sending them to
    // /tutorials shut them out of the one page built for them.
    // (user 2026-10-18: "i wan to give them dashboard to see their sales";
    //  user 2026-10-31, on exempting the role from the quiz gate: "1. yes")
    if (list.length > 0 && list.every(r => r === "Referral")) {
        return "/referral/dashboard";
    }

    // Not yet certified → the training room. Tutorials first, because that is what
    // the quiz examines; the quiz sits one click away in the same menu.
    // (user 2026-09-24)
    if (canCreateSale === false) {
        return "/tutorials";
    }

    // Viewer-only means EVERY role is Viewer — someone who is also an agent keeps
    // the normal landing page.
    if (list.length > 0 && list.every(r => r === "Viewer")) {
        return "/user/profile";
    }

    if (list.includes("Astern Admin")) {
        return "/accounting/sales";
    }

    return "/dashboard";
}
